export class EntryDictionary {

  static Complete = {
    exerciseComplete: '47P6sV46aAEG6aOcceYIWY'
  };

  static Dashboard = {
    dashboard: '28MyFyQGhycYiWkcS2SW2A'
  };

  static Exercise = {
    exercise: '1UBPErrlPye0GOU0Uc8esi'
  };

  static LogIn = {
    logIn: '2mK3LLKfPSqie4CiE88oSK'
  };

  static PaymentInfoBlock = {
    cancelBlock: '53MuNRbdPgIR75Y1GfXIjS',
    freeTrialBlock: '6NCvMSTNIHED4lt6fnjK3m',
    reminderBlock: '1kXgEobdnwIgBAEsuD4iaN'
  };

  static Persistence = {
    persistenceRound: '6cZWOyruhycemOEsmAok2C'
  };

  static Results = {
    exerciseResults: '24bHy2s1ViaGwqYeCEwumI'
  };

}

